import { Fragment } from 'react';

import { MenuItem } from '@/shared/components/nav/MenuItem';
import { posthogCapture } from '@/shared/vendor/posthog';

type SchedulingMenuItemProps = {
  workChatFree?: boolean;
  schedulerTrial?: boolean;
  isEmployee?: boolean;
  showTeamSchedule?: boolean | undefined;
  defaultMenuItem?: boolean | undefined;
};

export default function SchedulingMenuItem({
  workChatFree,
  schedulerTrial,
  isEmployee,
  showTeamSchedule,
  defaultMenuItem,
}: SchedulingMenuItemProps) {
  function onInteraction() {
    posthogCapture('top_nav.scheduler');
  }

  return (
    <Fragment>
      {workChatFree && (
        <MenuItem
          data-testid="top-nav-scheduler"
          onClick={onInteraction}
          icon="schedule"
          label="Schedule"
          to="/scheduler"
        />
      )}
      {schedulerTrial && (
        <MenuItem
          data-testid="top-nav-scheduler"
          onClick={onInteraction}
          className="disabled upsell"
          icon="schedule"
          label="Scheduling"
          to="/#scheduler-trial"
        />
      )}
      {isEmployee && (
        <MenuItem
          data-testid="top-nav-scheduler"
          onClick={onInteraction}
          icon="my-schedule"
          hideLabel="tablet"
          label="My Schedule"
          to="/myschedule"
        />
      )}
      {showTeamSchedule && typeof defaultMenuItem === 'undefined' && (
        <MenuItem
          data-testid="top-nav-scheduler"
          onClick={onInteraction}
          icon="schedule"
          hideLabel="tablet"
          label="Team Schedule"
          to="/scheduler"
        />
      )}
      {defaultMenuItem && typeof showTeamSchedule === 'undefined' && (
        <MenuItem
          data-testid="top-nav-scheduler"
          onClick={onInteraction}
          icon="schedule"
          hideLabel="tablet"
          label="Scheduler"
          to="/scheduler"
        />
      )}
    </Fragment>
  );
}
